module.exports = __webpack_public_path__ + "img/logo-login.e76a58f5.svg";